import { createContext } from "react";
const AdminOrdersContext = createContext();
export default AdminOrdersContext;
